const GENERAL = {
  logout: 'Ausloggen',
  my_account: 'Mein Konto',
  email: 'E-Mail',
  login: 'Einloggen',
  password: 'Passwort',
  enter_credentials: 'Geben Sie hier Ihre Zugangsdaten ein',
  welcome_message: 'Hallo, {name}',
  how_are_you: 'Wie geht es Ihnen heute?',
  and: 'Und',
  or: 'Oder',
  no_result: 'Keine Ergebnisse gefunden',
  attribute: 'Eigenschaft|Eigenschaften',
  add_to_cart: 'In den Warenkorb legen',
  amount: 'Menge',
  color: 'Farbe',
  area: 'Fläche',
  close: 'Schließen',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  add: 'Hinzufügen',
  update: 'Aktualisieren',
  contact_person: 'Kontaktperson vor Ort',
  street: 'Straße',
  street_additional: 'Ergänzung (Etage, Apartment, etc.)',
  city: 'Stadt',
  zip_code: 'PLZ',
  country: 'Land',
  firstname: 'Vorname',
  lastname: 'Nachname',
  company: 'Firma',
  language: 'Sprache',
  delivery_address: 'Lieferadresse|Lieferadressen',
  your_profile: 'Ihr Profil',
  back: 'Zurück',
  general: 'Allgemein',
  yes: 'Ja',
  no: 'Nein',
  next: 'Weiter',
  notes: 'Bemerkungen',
  your_data: 'Ihre Daten',
  address: 'Adresse',
  details: 'Details',
  created_at: 'Erstellt am',
  recent_user: 'Neuste User',
  recent_user_requests: 'Neuste Useranfragen',
  user_requests: 'Useranfragen',
  username: 'Benutzername',
  general_config: 'Einstellungen',
  salution: 'Anrede',
  submit: 'Absenden',
  phone: 'Telefon',
  user: 'Benutzer',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  files: 'Datei|Dateien',
  print: 'Drucken',
  no_files: 'Keine Datenblätter vorhanden',
  news: 'News',
  recent_cart_requests: 'Letzte Anfragen',
  recent_cart_orders: 'Letzte Bestellungen',
  more: 'Mehr',
  name: 'Name',
  mr: 'Herr',
  ms: 'Frau',
  divers: 'Divers',
  orders: 'Bestellungen',
  requests: 'Anfragen',
  customer: 'Kunde',
  interestedParty: 'Interessent',
  other_information: 'Weitere Informationen',
  reject: 'Ablehnen',
  confirm: 'Bestätigen',
  done: 'Erledigt',
  add_new_address: 'Neue Adresse hinzufügen',
  address_added: 'Adresse wurde angelegt',
  add_contact_person: 'Bitte Kontaktperson angeben',
  add_streetname: 'Bitte Straße angeben',
  add_postcode: 'Bitte PLZ angeben',
  add_city: 'Bitte Stadt angeben',
  add_country: 'Bitte Land angeben',
  add_company: 'Bitte Firma angeben',
  nothing_found: 'Nichts gefunden',
  not_registered_yet: 'Noch nicht registriert?',
  login_failed: 'Login fehlgeschlagen',
  add_user: 'User hinzufügen',
  actions: 'Aktionen',
  status: 'Status',
  last_request_deleted: 'Letzte Anfrage wurde gelöscht',
  leave_empty: 'Leer lassen für automatische Erstellung',
  reset_filter: 'Filter zurücksetzen',
  loading: 'Lädt',
  no_products: 'Keine Produkte',
  scan_for_articlenumber: 'QR-Code scannen',
  total_weight: 'Gesamtgewicht',
  further_informations: 'Weitere Informationen',
  forgot_password: 'Passwort vergessen?',
  forgot_password_message: 'Wenn du dein Passwort vergessen hast, kannst du es hier zurücksetzen.',
  reset_password_message: 'Bitte gib dein neues Password ein.',
  share: 'Teilen',
  user_details: 'Benutzerdetails',
  reset_email: 'Soll eine "Reset Passwort Email" verschickt werden?',
  please_confirm: 'Bitte bestätigen',
  reset_password: 'Passwort zurücksetzen',
  password_change: 'Passwort ändern',
  admin: 'Adminbereich',
  street_and_housenumber: 'Straße und Hausnummer',
  back_to_app: 'Zurück zur App',
  percentage: 'Anteil',
  qcvsand: 'Quarzsand',
  add_flake: 'Flake hinzufügen',
  add_sand: 'Sand hinzufügen',
  flakes: 'Flakes',
  request: 'Anfrage',
  selection: 'Auswahl',
  add_: 'Add',
  mixing_ratio: 'Mischverhältnis',
  preview: 'Vorschau',
  remarks: 'Bemerkungen',
  type: 'Art',
  mixer_requests: 'Mixeranfragen',
  groundcolor: 'Grundfarbe',
  remove: 'Entfernen',
};

export default GENERAL;
